import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'antd';
import Translate from 'react-translate-component';
import { contains, propEq, find } from 'ramda';
import { connect } from 'react-redux';

import { fullAutoOptions } from 'constants/asyncClient';
import ModalCloseButton from 'components/modals/ModalCloseButton';
import { getProject, getUser } from 'actions/asyncActions';
import ProjectCard from 'components/cards/project/ProjectCard';
import { worksheet, worksheetMassStage } from 'constants/routes';
import { MASS_WORKSHEET_TYPES } from 'constants/worksheet';
import CollapsibleModalContainer from '../CollapsibleModalContainer';
import CustomIcon from 'components/common/CustomIcon';

const isMassProject = (projectType) => contains(projectType, MASS_WORKSHEET_TYPES);

const getWorksheetLink = (projectType, id, stage) => (
    isMassProject(projectType) ? (
        worksheetMassStage.stringify({ id, stage })
    ) : (
        worksheet.stringify({ id })
    )
);

const Title = ({ id, close, name, projectType, stage, useNavLink }) => (
    useNavLink ? (
        <div>
            <Tooltip title={<Translate content="project.to_worksheet" />}>
                <NavLink to={getWorksheetLink(projectType, id, stage)} className="m-r-8">
                <CustomIcon type="table" onClick={close} />
              </NavLink>
            </Tooltip>
            { name }
        </div>
    ) : (
        <div>
            <Tooltip title={<Translate content="worksheetMass.toolTips.notParticipant" />}>
                <CustomIcon type="table" className='without-navlink' />
            </Tooltip>
            { name }
        </div>
    )
);

const stateToProps = (state) => ({
    userId: getUser.selectData(state).id,
});

@connect(stateToProps)
@withAsyncActions({
    getProject: getProject
        .withParams(({ params: { id } }) => ({ id }))
        .withPayload(({ params: { id } }) => id)
}, fullAutoOptions)
export default class ProjectModal extends Component {
    render() {
        const { close, getProject: { data: project, meta }, closeAll, params: { text, id }, userId } = this.props;
        const { projectType, firstStageKey, participants } = project;
        const footer = <ModalCloseButton close={close} />;
        const useNavLink = projectType && (isMassProject(projectType) ? !!find(propEq('id', userId))(participants) : true);

        return (
            <CollapsibleModalContainer
                meta={meta}
                title={<Title
                    id={id}
                    close={closeAll}
                    name={text}
                    projectType={projectType}
                    stage={firstStageKey}
                    useNavLink={useNavLink}
                />}
                footer={footer}>
                <ProjectCard project={project} meta={meta} />
            </CollapsibleModalContainer>
        )
    }
}
